const projects = [
  {
    title: "TrackIt - Fitness & Performance Tracker",
    description:
      "A cross-platform mobile app for track and field athletes to log workouts, track performance, and gain AI-powered insights. Features include sprint timing, equipment logging, personal bests, track meet records, injury tracking, and data visualization. Available on both iOS and Android.",
    technologies: [
      "React Native",
      "JavaScript",
      "Node.js",
      "MySQL",
      "REST API",
      "Google Generative AI",
      "Chart JS",
    ],
    website: "https://www.trackittf.com",
    playStore:
      "https://play.google.com/store/apps/details?id=com.benayesu.trackit",
    appStore: "https://apps.apple.com/ca/app/trackit-fitness/id6743180546",
    github: "https://github.com/Ben-ayesu/trackit",
    video: "/videos/trackittf.mp4",
  },
  {
    title: "Sales Tax Calculator",
    description:
      "Calculates state and provincial sales tax. Features predefined tax rates for multiple states/provinces, streamlined calculation processes and an intuitive user interface. Achieved over 15,000 downloads on the Google Play Store.",
    technologies: ["Kotlin", "Jetpack Compose", "MVVM", "Material Design"],
    link: "https://play.google.com/store/apps/details?id=salestaxcalculator.example.bcsalestax",
    github: "https://github.com/Ben-ayesu/Sales_Tax",
    video: "/videos/out.mp4",
  },
  {
    title: "Balanced Embodied Elite",
    description:
      "Developed a website for Balanced Embodied, an athletic performance and wellness company, to showcase their services, training programs, and expert team. The site features a modern design, smooth animations, and clear information architecture to enhance user engagement and promote the company's brand.",
    technologies: [
      "JavaScript",
      "TypeScript",
      "React JS",
      "TailwindCSS",
      "HTML",
      "Framer motion",
    ],
    link: "https://balanceembodiedelite.com/",
    github: "https://github.com/Ben-ayesu/atg",
    video: "/videos/beembodied.mp4",
  },
  {
    title: "Track it (Web)",
    description:
      "The original web-based version of Track it — a sprint workout tracking app built during BrainStation bootcamp. Helps athletes log, analyze, and visualize performance data with precise timing, distance tracking, repetition logging, and customizable graphs.",
    technologies: [
      "JavaScript",
      "Node.js",
      "React JS",
      "MySQL",
      "REST API",
      "HTML",
      "SCSS",
    ],
    link: "https://sprint-trackit.netlify.app/login",
    github: "https://github.com/Ben-ayesu/trackit-capstone",
    video: "/videos/trackit.mp4",
  },
  {
    title: "yldlyfe - E-commerce Website",
    description: "Developed a user-friendly landing page for yldlyfe.",
    technologies: [
      "TypeScript",
      "CSS",
      "JavaScript",
      "Tailwind CSS",
      "Framer motion",
    ],
    link: "https://yldlyfe.vercel.app/",
    github: "https://github.com/Ben-ayesu/yldlyfe",
    video: "/videos/yldlyfe-landing.mp4",
  },
  {
    title: "Restaurant Reservation App",
    description:
      "Designed and built a mobile restaurant reservation app, enabling users to browse restaurant listings, select available time slots, and book reservations seamlessly. Developed with a focus on user-friendly interfaces.",
    technologies: ["Swift", "SwiftUI"],
    github: "https://github.com/Ben-ayesu/Little-Lemon-reservation-app",
    video: "/videos/Littlelemon.mp4",
  },
];

export default projects;
